import { Icons, ChakraFlex as Flex, ChakraBox as Box, ChakraText as Text } from "@airhelp/react-ui-components";
import { useLanguage } from "contexts/LocalizationContext";
import { useDeviceSize } from "hooks";
import { getPageUrl } from "utils/getPageUrl";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import { BarcodeScannerIcon } from "./BarcodeScannerIcon";
import type { BarcodeScannerButtonProps } from "./BarcodeScannerButton.d";

const HERO_BARCODE_SCANNER_EVENT_UA = ["clicked", "Hero", "CheckYourCompensationBarcode"] as const;
const HERO_BARCODE_SCANNER_EVENT = {
  event: "cta_click",
  label: "check_your_compensation_barcode",
  placement: "hero",
} as const;

const BarcodeScannerButton = ({ buttonText, dividerText }: BarcodeScannerButtonProps) => {
  const language = useLanguage();
  const { isMobile } = useDeviceSize();

  const handletrackEvents = () => {
    trackUAEvent(HERO_BARCODE_SCANNER_EVENT_UA);
    trackCustomEvent(HERO_BARCODE_SCANNER_EVENT);
  };

  if (!isMobile) return null;
  return (
    <Box w="full">
      <Text textAlign="center" fontSize="sm" my={2} color="greyscale.500">
        {dividerText && dividerText}
      </Text>

      <Flex
        as="a"
        bgColor="primary.200"
        p={3}
        borderRadius="8px"
        fontWeight="medium"
        alignItems="center"
        justifyContent="space-between"
        href={getPageUrl(language, "webappBarcodeScanner")}
        onClick={handletrackEvents}
      >
        <BarcodeScannerIcon boxSize={10} bgColor="white" mr={3} borderRadius="4px" />
        {buttonText}
        <Icons.AltArrowForward boxSize={6} color="primary.500" />
      </Flex>
    </Box>
  );
};

export default BarcodeScannerButton;
